import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Button(theme: Theme): Components<Theme> {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
          "&.MuiButton-text.MuiButton-loadingPositionStart": {
            "& .MuiButton-startIcon": {
              marginLeft: 0,
            },
          },
          "&.MuiButton-text.MuiButton-loadingPositionEnd": {
            "& .MuiButton-endIcon": {
              marginRight: 0,
            },
          },
          variants: [
            {
              props: { size: "large" },
              style: {
                height: 48,
                minHeight: 48,
              },
            },
            {
              props: { variant: "contained", color: "inherit" },
              style: {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.grey[800],
                boxShadow: theme.customShadows.z8,
                "&:hover": {
                  color: theme.palette.common.white,
                  backgroundColor: theme.palette.grey[800],
                },
              },
            },
            {
              props: { variant: "contained", color: "primary" },
              style: {
                boxShadow: theme.customShadows.primary,
              },
            },
            {
              props: { variant: "contained", color: "secondary" },
              style: {
                boxShadow: theme.customShadows.secondary,
              },
            },
            {
              props: { variant: "contained", color: "info" },
              style: {
                boxShadow: theme.customShadows.info,
              },
            },
            {
              props: { variant: "contained", color: "success" },
              style: {
                boxShadow: theme.customShadows.success,
              },
            },
            {
              props: { variant: "contained", color: "warning" },
              style: {
                boxShadow: theme.customShadows.warning,
              },
            },
            {
              props: { variant: "contained", color: "error" },
              style: {
                boxShadow: theme.customShadows.error,
              },
            },
            {
              props: { variant: "outlined", color: "inherit" },
              style: {
                border: `1px solid ${theme.palette.grey[500_32]}`,
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              },
            },
            {
              props: { variant: "text", color: "inherit" },
              style: {
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              },
            },
          ],
        },
      },
    },
  };
}
